<template>
    <div>
        <my-form 
        class="form-page" 
        v-model="form" 
        table 
        label-width="180px" 
        @cancle="cancleHandler" 
        @submit="fsave">
           
            <el-form-item 
            label="项目名称"
            prop="proname"
            :rules="newRule('项目名称', 'required')">
                {{form.proname}}
            </el-form-item>

            <el-form-item
            prop="prohyflcode" 
            label="所属行业"
            :rules="newRule('所属行业', 'required')">
                <cascader-hy
                v-model="form.prohyflcode"
                2way="text"
                @hysorname="hysorname"
                :text.sync="form.prohyflname"
                placeholder="选择项目所属行业">
                </cascader-hy>
            </el-form-item>

            <el-form-item 
            label="项目类别"
            prop="xmlbcode" 
            class="table-full-row"
            :rules="newRule('项目类别', 'required')">
                <my-radio
                v-model="form.xmlbcode"
                :data="xmlbList"
                2way="value"
                :value.sync="form.xmlbname">
                </my-radio>
                <div style="margin-top:10px" v-if="form.xmlbcode==='101'">
          
                    <el-checkbox-group v-model="recordList" @change="clickrecord">
                        <el-checkbox 
                        v-for="item in model.recordtype"
                        :disabled="item.diccode!=='0'&&recordList[0]==='0'"
                        :label="item.diccode">
                            {{item.dicname}}
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
            </el-form-item>

            <el-form-item 
            label="监管部门"
            prop="ext_deptcode"
            class="table-full-row"
            :rules="newRule('监管部门', 'required')">
                {{form.ext_deptname}}
            </el-form-item>

            <el-form-item 
            label="项目级别"
            prop="ext_prolevelcode"
            :rules="newRule('项目级别', 'required')">
                {{form.ext_prolevelname}}
            </el-form-item>

            <el-form-item 
            label="招标人"
            prop="faren"
            :rules="newRule('招标人', 'required')">
                <el-input v-model="form.faren"></el-input>
            </el-form-item>

            <el-form-item 
            label="资金来源"
            prop="zjlycode"
            :rules="newRule('资金来源', 'required')" class="zjly table-full-row">
                <el-checkbox-group v-model="checkList" @change="setZjly" >
                    <el-checkbox :label="item.label" v-for="(item,i) in zjlylist" :key="i">{{item.value}}</el-checkbox> 
                </el-checkbox-group>
                <div v-if="zfxianshi==true" class="zf" >
                    出资比例（政府）：<el-input-number  v-model="form.zfnum" @change="zfChange" :min="0" :max="100" label="描述文字" style="width:250px" > </el-input-number> 
                </div>
                <div v-if="qyxianshi==true" class="qy">
                    出资比例（企业）：<el-input-number  v-model="form.qynum" @change="qyChange" :min="0" :max="100" label="描述文字" style="width:250px" > </el-input-number> 
                </div>
                <div v-if="qtxianshi==true" class="qt">
                    出资比例（其他）：<el-input-number  v-model="form.qtnum" @change="qtChange" :min="0" :max="100" label="描述文字" style="width:250px" > </el-input-number> 
                </div>
                <!-- {{checkList}} {{form.zjlycode}} -->
            </el-form-item>
            <el-form-item 
            label="资金来源详细内容"
            prop="zjly"
            :rules="newRule('资金来源详细内容', 'required')" class="table-full-row">
                <el-input 
                    v-model="form.zjly" 
                    placeholder=""
                    type="textarea" 
                    :autosize="{ minRows: 4, maxRows: 10}">
                </el-input>
            </el-form-item>

            <el-form-item 
            label="招标估算额(万元)"
            prop="e_zbgse"
            :rules="newRule('招标估算额(万元)', 'required')">
                <el-input style="width:200px" v-model="form.e_zbgse"></el-input>
            </el-form-item>

            <el-form-item 
            label="项目所属地区" 
            prop="procitycode"
            :rules="newRule('项目所属地区', 'required')">
                <div style="overflow:hidden">
                    <my-select
                    class="form-item_half"
                    v-model="form.xzqycode"
                    :data="model.shenglist"
                    :props="{value:'diccode',label:'dicname'}"
                    @select="getxian(form.xzqycode)"
                    2way="dicname"
                    :dicname.sync="form.xzqyname"
                    placeholder="选择地市">
                    </my-select>
                    
                    <my-select
                    class="form-item_half"
                    v-model="form.procitycode"
                    :data="xianList"
                    :props="{value:'cityid',label:'name'}"
                    placeholder="选择县区"
                    2way="name"
                    :name.sync="form.procityname"
                    :disabled="!form.xzqycode">
                    </my-select>

                 
                </div>
      
            </el-form-item>

            <el-form-item 
            label="项目地址"
            prop="proaddress"
            :rules="newRule('项目地址', 'required')">
                {{form.proaddress}}
            </el-form-item>

            <el-form-item 
            label="项目规模"
            prop="xmgm"
            class="table-full-row"
            :rules="newRule('项目规模', 'required')">
                <el-input 
                v-model="form.xmgm" 
                type="textarea" 
                :autosize="{ minRows: 4, maxRows: 10}">
                </el-input>
            </el-form-item>

            <el-form-item 
            label="建设内容"
            prop="e_jsnr"
            class="table-full-row"
            :rules="newRule('建设内容', 'required')">
                <el-input 
                v-model="form.e_jsnr" 
                type="textarea" 
                :autosize="{ minRows: 4, maxRows: 10}">
                </el-input>
            </el-form-item>

            <el-form-item 
            label="资金到位情况"
            prop="zjdwqk"
            :rules="newRule('资金到位情况', 'required')">
                <el-input v-model="form.zjdwqk"></el-input>
            </el-form-item>

            <el-form-item 
            label="技术等级"
            prop="jsdj"
            :rules="newRule('技术等级', 'required')">
                <el-input v-model="form.jsdj"></el-input>
            </el-form-item>

            <el-form-item 
            label="招标单位负责人"
            prop="e_xmfzr"
            :rules="newRule('招标单位负责人', 'required')">
                <el-input v-model="form.e_xmfzr"></el-input>
            </el-form-item>

            <el-form-item 
            label="负责人联系方式"
            prop="e_fzrphone"
            :rules="newRule('负责人联系方式', 'required')">
                <el-input v-model="form.e_fzrphone"></el-input>
            </el-form-item>



            <template slot="btn" slot-scope="scope">
                <el-button 
                @click="saveHandler(1, scope.submitHandler)" 
                v-if="isRevision!=1||newType=='oldEditPro'"
                type="primary" 
                icon="el-icon-circle-check">
                    提交
                </el-button>
                <el-button 
                @click="saveHandler(1, scope.submitHandler)" 
                v-if="isRevision==1&&newType!='oldEditPro'"
                type="primary" 
                icon="el-icon-circle-check">
                    提交并增加招标项目
                </el-button>
                <el-button 
                @click="saveHandler(0, scope.submitHandler)" 
                v-if="isRevision!=1"
                type="warning" 
                icon="el-icon-remove-outline">
                    暂存
                </el-button>
                <el-button 
                v-if="form.xzqycode=='130500'"
                @click="saveHandler('dzxy', scope.submitHandler)" 
                type="success" 
                icon="el-icon-monitor">
                    电子协议
                </el-button>
                <el-button 
                icon="el-icon-circle-close" 
                @click="scope.cancleHandler">
                    取消
                </el-button>

                <div style="margin-top:10px">
                    <my-tag type="danger">招标公告未发布前，如发现问题可在菜单：综合管理-修改审核状态 处自行退回。</my-tag>
                </div>
                
            </template>
        </my-form>
        <!--电子协议-->
        <my-dialog
        v-model="dialogVisible"
        :title="dialogTitle"
        @close="diaclose"
        width="80%">
            <form-elec-agree
            v-if="dialogVisible"
            :type="type"
            :row="row"
            @cancle="diaclose">
            </form-elec-agree>
        </my-dialog>

    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'
import DIALOG_LIST_PAGE from "@views/mixins/dialog-list-page";
import FormElecAgree from '@views/bidding/elec-agreement/form'
import CascaderHy from "@views/bidding/components/cascader-hy";


export default {
    mixins: [ FORM_PAGE_MIXIN,DIALOG_LIST_PAGE],
    components: {
        CascaderHy,FormElecAgree
    },

    data: () => ({
        form:{
            zfnum:'',
            qynum:'',
            qtnum:'',
            zjlycode:'',
            zjly:'',
            czbl:'',
            zjlyList:'',
            zjdwqk:'',
            jsdj:'',
        },
        checkList:[],
        // zfnum:0,
        // qynum:0,
        // qtnum:0,
        zfxianshi:false,
        qyxianshi:false,
        qtxianshi:false,
        zjlylist:[
            {value:'政府',label:'1'},
            {value:'企业',label:'2'},
            {value:'其他',label:'9'},
        ],
        model:{},
        recordList:[],
        xmlbList:[
            {key:'100', value:'审批（核准）类'}, 
            {key:'101', value:'备案类'}, 
            {key:'102', value:'无需审批、核准、备案类'}
        ],
        
        xianList:[],
        dialogVisible:false,
        type:'1',
        dialogTitle:'电子协议',
        row:{
            procode:'',
        },
        isRevision:0,
        newType:'',
    }),
    watch: {
        
    },
    methods: {
        formInit(queryData,val,getproUrl){
            var that = this
            
            that.jspInit(getproUrl, queryData, data => {
                that.form = data.model
                that.form.spxmbh = that.form.spxmbh.trim();
                that.model = data
                that.$set(this.form, 'zfnum', 0)
                that.$set(this.form, 'qtnum', 0)
                that.$set(this.form, 'qynum', 0)
                var zjlyList=[]
                zjlyList=data.zjlyList
                console.log(zjlyList)
                if(zjlyList!=null){
                    zjlyList.forEach(function(item){
                        // debugger
                        that.checkList.push(item.zjlycode)
                        console.log(that.checkList)
                        if(item.zjlycode=='1') {
                            that.form.zfnum=Number(item.czbl.substring(0,item.czbl.length-1))
                            that.zfxianshi=true
                        }
                        if(item.zjlycode=='2') {
                            that.form.qynum=Number(item.czbl.substring(0,item.czbl.length-1))
                            that.qyxianshi=true
                        }
                        if(item.zjlycode=='9') {
                            that.form.qtnum=Number(item.czbl.substring(0,item.czbl.length-1))
                            that.qtxianshi=true
                        }
                    })
                }
                if(that.form.by5==''||that.form.by5==null){
					that.form.by5= data.xmbm;
				}
                // 循环备案类型 添加其它选项
                that.model.recordtype.push({ 
                    diccode: "0",
                    dicname: "其他"
                })
                
                // 给选中的项目类型  项目级别  主管行业 添加name
                if(!that.form.xmlbname){
                    that.xmlbList.forEach(function(item){
                        if(item.key===that.form.xmlbcode){
                            that.form.xmlbname = item.value
                        }
                    })
                }

                // 判断是否编辑
                if(val==='1'){
                    // 判断是否是北京和天津
                    if(that.form.procitycode.substr(0, 2)=='11'||that.form.procitycode.substr(0, 2)=='12'){
                        that.form.xzqycode = that.form.procitycode.substr(0, 2)+ "0000";
                    }else{
                        that.form.xzqycode = that.form.procitycode.substr(0, 4)+ "00";
                    }
                    if(that.form.procitydisname){
                        that.form.xzqyname = that.form.procitydisname.split('-')[0]
                        that.form.procityname = that.form.procitydisname.split('-')[1]
                    }
                    if(that.form.xmlbcode==='101'){
                        that.recordList = that.form.record_type.split(';')
                    }
                    that.getxian(that.form.xzqycode,'1')
                }else{
                 
                    // 获取项目基本信息 新增状态
                    that.$post(`${that.getGetters('mngUrl')}/getsjjtxm/getProInfo.json`,{
                        hzwh:that.form.spxmbh,
                    }, data => {
                        var obj = data
                        that.form.zjly = obj.zjlyjgc;
                        that.form.proaddress = obj.address;
                        that.form.faren = obj.faren;
                        that.form.lxr = obj.lxr;
                        that.form.zjdwqk = obj.zjdwqk;
                        that.form.jsdj = obj.jsdj;
                        that.form.proname = obj.proname;
                        that.form.e_xmbtel = obj.phone;
                        that.form.sjly = "0";
                        that.form.xmlx = "1";
                        that.form.ext_deptname ='交通部门'
                        that.form.ext_prolevelname ='省级项目'
                    })
                   
                    that.form.procode = ''
                }

            })
        },
        // 选择备案类型 其他
        clickrecord(val){
            var that = this
            val.forEach(function(item){
                if(item==='0'){
                    that.recordList = []
                    that.recordList = ['0']
                }
            })
            
        },
        
        // 获取县区
        getxian(xzqycode,val){
            var that = this
            if(!val){
                that.form.procitycode = '';
            }
            if(xzqycode){
                that.$get(`${that.getGetters('mngUrl')}/common/getcitylist.json`,{
                    citycode:xzqycode,
                }, data => {
                    that.xianList = data
                    
                })
            }
           
        },
        setZjly(data){
            this.form.zjlycode=data.join(';')
            console.log(data)
            this.zfxianshi=false
            this.qyxianshi=false
            this.qtxianshi=false
            // this.form.zfnum=0
            // this.form.qynum=0
            // this.form.qtnum=0
            console.log(data.indexOf(2)===-1)
            if(data.indexOf('1')!==-1) {
                this.zfxianshi=true
            }
        
            if(data.indexOf('2')!==-1) {
                this.qyxianshi=true
            }
          
            if(data.indexOf('9')!==-1) {
                this.qtxianshi=true
            }
         

            // this.form.ggfbmt=data.toString()
            // console.log(this.form.ggfbmt)
        },
        zfChange(data) {
            this.form.zfnum=data
            console.log(data)
        },
        qyChange(data) {
            this.form.qynum=data
            console.log(data)
        },
        qtChange(data) {
            this.form.qtnum=data
            console.log(data)
        },
        // 保存验证  数据填写
        saveHandler(type,cb){
            this.form.record_type = this.recordList.join(';')
            
            if(this.form.xmlbcode==='101'&&!this.form.record_type){
                ShowMsg('请选择项目类别','warning')
                return
            }
            this.form.procitydisname = this.form.xzqyname + '-' + this.form.procityname
            this.form.shbj = type
            cb && cb();
        },
        // 保存
        fsave(){
            var zjlyList=[]
            var zfczbl={};
            var qyczbl={};
            var qtczbl={};
            var zfczblnum=this.form.zfnum+'%';
            var qyczblnum=this.form.qynum+'%';
            var qtczblnum=this.form.qtnum+'%';
            if(this.form.zjlycode.indexOf('1')!==-1) {
                zfczbl.zjlycode='1'
                zfczbl.zjlyname='政府'
                zfczbl.czbl=zfczblnum
                zjlyList.push(zfczbl)
            }
            if(this.form.zjlycode.indexOf('2')!==-1) {
                qyczbl.zjlycode='2'
                qyczbl.zjlyname='企业'
                qyczbl.czbl=qyczblnum
                zjlyList.push(qyczbl)
            }
            if(this.form.zjlycode.indexOf('9')!==-1) {  
                qtczbl.zjlycode='9'
                qtczbl.zjlyname='其他'
                qtczbl.czbl=qtczblnum
                zjlyList.push(qtczbl)
            }
            
            this.form.zjlyList=JSON.stringify(zjlyList)
            var that = this;
            if(that.form.shbj=='dzxy'){
                that.form.shbj = '0';
                var url = '';
                if(that.isRevision!=1){
                    url = `${that.getGetters('mngUrl')}/Zbdl/Project/add.json`;
                }else{
                    url = `${that.getGetters('mngUrl')}/v2/Zbdl/ZbProject/submitProInfo.json`;
                }
                that.$post(url,that.form, data => {
                    that.row.procode = data.procode;
                    that.form.procode = data.procode;
                    that.dialogVisible = true;
                }) 
            }else{
                if(that.newType=='oldEditPro'){
                    that.$post(`${this.getGetters('mngUrl')}/Zbdl/Project/add.json`,that.form, data => {
                        ShowMsg('保存成功','success');
                        window.top.$tagFrame.pushTag({
                            src:`/Zbdl/ZbProject/edit?id=`+that.getQuery('zbprocode')+'&newType=edit&t='+Math.random(),
                            title:'添加建设工程项目',
                            type: 'href',
                            topparent:'common-tag',
                        })
                        
                    }) 
                }else{
                    if(that.isRevision!=1){
                        that.$post(`${this.getGetters('mngUrl')}/Zbdl/Project/add.json`,that.form, data => {
                            ShowMsg('保存成功','success');
                            that.goto({
                                path: '/bidding/project/list',
                            });
                        }) 
                    }else{
                        that.$post(`${this.getGetters('mngUrl')}/v2/Zbdl/ZbProject/submitProInfo.json`,that.form, data => {
                            ShowMsg('保存成功','success');
                            // this.gotoFrame({
                            //     title:'修改招标项目',
                            //     url:'/Zbdl/ZbProject/edit',
                            // })
                            var obj = data;
                            that.$post(`${this.getGetters('mngUrl')}/getsjjtxm/getxmlx.json`,{
                                procode:obj.procode
                            }, (data, res) => {
                                var strResult = '';
                                if(res.result){
                                    var xmlx = res.t;
                                    strResult = obj.procode+"$"+escape(obj.proname)+"$"+xmlx;
                                }else{
                                    strResult=obj.procode+"$"+escape(obj.proname);
                                } 
                                window.top.$tagFrame.pushTag({
                                    src:'/Zbdl/ZbProject/edit?strResult='+strResult+'&newType=add',
                                    title:'添加建设工程项目',
                                    type: 'href',
                                    topparent:'common-tag',
                                })
                            })
                            
                        }) 
                    }
                }
            }
            
        },
        // 取消
        cancleHandler(){
            var that = this;
            // this.goto({
            //     path: '/bidding/project/list',
            // });
            ShowConfirm('确认关闭项目信息？关闭后将不保存该项目信息。', 'warning', () => {
                if(that.form.scbj==1&&getSession('isRevision')==1){
                    that.$post(`${that.getGetters('mngUrl')}/Zbdl/Project/del.json`,{
                        id:that.form.procode,
                        oper:'del'
                    }, (data, res) => {
                       
                    });
                }
                if(getSession('isRevision')!=1){
                    that.$router.go(-1);
                }else{
                    // 关闭当前标签
                    window.top.$tagFrame.popTagByIndex(window.top.$tagFrame.getActiveTag().index)
                }
            })
        },
        // 关闭弹窗
        diaclose(){
            var that = this;
            this.dialogVisible = false;
            // var url = window.location.href.split("?");
            // window.location.href = url[0]+'?id='+this.form.procode;
            if(getSession('isRevision')!=1){
                this.$router.go(-1);
            }else{
                if(!that.getQuery('id')){
                    window.top.$tagFrame.pushTag({
                        src:window.location.pathname+'?t='+Math.random()+'/'+window.location.hash+'&id='+that.row.procode,
                        title:'添加政府采购项目',
                        type: 'href',
                        topparent:'common-tag',
                    })
                }else{
                    window.top.$tagFrame.pushTag({
                        src:window.location.pathname+'?t='+Math.random()+'/'+window.location.hash,
                        title:'添加政府采购项目',
                        type: 'href',
                        topparent:'common-tag',
                    })
                }
            }
        },
        // 选择标段分类 
        hysorname(val){
            this.form.prohyflname = val
        }
      
    },
    created() {
        var that = this
        that.isRevision = getSession('isRevision');
        that.newType = that.getQuery('newType');
        var queryData = {}
        if(that.getQuery('id')){
            queryData = {
                id:that.getQuery('id'),
            }
            that.formInit(queryData,'1',`${that.getGetters('ageUrl')}/Zbdl/Project/edit.json`)
        }else{
            queryData = {
                xmly:that.getQuery('ly'),
                xmbm:that.getQuery('xmbm'),
                xmlbcode:that.getQuery('xmlbcode'),
                prolevelcode:that.getQuery('prolevelcode'),
                hyjgbmcode:that.getQuery('hyjgbmcode'),
                iszfcg:that.getQuery('iszfcg'),
                ggzy:that.getQuery('ggzy'),
            }
            that.formInit(queryData,'0',`${that.getGetters('ageUrl')}/getsjjtxm/edit.json`)
        }

    },
    mounted() {
        
    },
}
</script>

<style scoped lang="scss">
/deep/ .el-radio{ margin-top: 10px;}
/deep/ .el-checkbox-group{ margin-left: 150px;}
/deep/ .el-checkbox{ display: block; }
/deep/ .el-input.is-disabled .el-input__inner{ color: #333; }
/deep/ .zjly .el-checkbox-group{ margin-left:0px;}
.zjly {
    position: relative;
}
.zf {
    position: absolute;
    top: 5px;
    left: 110px;
}
.qy {
    position: absolute;
    top: 37px;
    left: 110px;
}
.qt {
    position: absolute;
    top: 69px;
    left: 110px;
}
/deep/ .zjly .el-checkbox {
    width: 100px;
}
</style>
